// import Swiper JS
import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);

// import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

export default class Missions {
    namespace: string = 'missions';

    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            const missionsContainerAll = document.querySelectorAll<HTMLDivElement>('.custom-container-missions');
            const uagbBlockAll = document.querySelectorAll<HTMLElement>('.entry-content > section');

            if (missionsContainerAll.length) {
                missionsContainerAll.forEach($missionSection => {
                    this.init($missionSection);
                });
            }

            if (uagbBlockAll.length) {
                uagbBlockAll.forEach($uagbBlock => {
                    this.addClassToParents($uagbBlock);
                })
            }
        }, false);
    }

    addClassToParents($uagbBlock: HTMLElement) {
        if ($uagbBlock.querySelectorAll('.custom-container-missions').length) {
            $uagbBlock.classList.add('block-has-missions');
        }
    }

    init($missionSection: HTMLDivElement) {
        const missionId = $missionSection.getAttribute('id');
        // console.log($missionSection.getAttribute('id'));
        new Swiper('#' + missionId + ' .swiper', {
            spaceBetween: 15,
            autoHeight: false,
            slidesPerView: 1.8,
            centerInsufficientSlides: true,
            modules: [Pagination],
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '#' + missionId + ' .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                }
            }
        })
    }
}
